import $ from 'jquery'
!function(){
    /* Create modal html and global variables */
    let modal,
        images = [],
        carouselItems,
        //$ = jQuery.noConflict(),
        modalHtml = `
        <div class="modal fade modal-gallery" data-modal="modal-gallery" id="gs-gallery" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div id="gs-gallery-carousel" class="carousel w-100 gallery carousel-fade" data-interval="5000" data-ride="carousel">
                        <div class="carousel-inner">
                            
                        </div>
                        <a class="carousel-control-prev" href="#gs-gallery-carousel" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" ></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#gs-gallery-carousel" role="button" data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>` ,

    nodes = [...document.querySelectorAll('#content .gallery-lightbox figure.wp-block-gallery .blocks-gallery-item>img, .figure>a.figure-img[rel~="lightbox"]>img')];
    /* Looking for the images and collect their data (src, capton) in the images array */

    document.querySelectorAll('.figure>a.figure-img[rel~="lightbox"]').forEach(el => {
        el.removeAttribute('href');
    })

    nodes.forEach(function(node){
        
        let src = node.src;
        let figcaptionNode = node.parentElement.querySelector('figcaption');
        let caption = figcaptionNode ? figcaptionNode.innerHTML : "";
        images.push({src, caption});

		node.setAttribute("role", "button");

        node.parentElement.addEventListener('click', function(e){
            /* At the first click on an image:
                - Insert the modal html markup
                - Insert all of the carousel items with the images
                - Add event listener to modal to show and remove blur
            */
            if (!modal){
                document.querySelector('#modal-default').insertAdjacentHTML('beforebegin',modalHtml);
                modal = document.querySelector("#gs-gallery");
                $(modal).on('show.bs.modal', function(event) {
                    $(`body > *:not("[data-modal]")`).addClass('blur');
                });
        
                $(modal).on('hide.bs.modal', function(event) {
                    $(`body > *:not("[data-modal]")`).removeClass('blur');
                });
                images.forEach(function(image){
                    let figcaption = image.caption ? `<figcaption>${image.caption}</figcaption>` : "";
                   
                    let carouselItem = `
                        <div class="carousel-item">
                            <div class="embed-responsive embed-responsive-16by9">
                                <div class="embed-responsive-item">
                                    <figure class="figure">
                                        <img class="img-contain" src=${image.src} alt="" />
                                        ${figcaption}
                                    </figure>
                                </div>
                            </div>
                        </div>  
                    `
                    document.querySelector('#gs-gallery-carousel>.carousel-inner').insertAdjacentHTML('beforeend',carouselItem);
                });
                carouselItems = document.querySelectorAll('#gs-gallery-carousel .carousel-item');
            }

            let isTheSame = false;
            carouselItems.forEach(item => {
				if((item.querySelector('img').src === this.firstChild.src || item.querySelector('img').src === this.querySelector('img').src) && !isTheSame){
                    item.classList.add('active');
                    isTheSame = true;
				} else {
					item.classList.remove('active')
                }
            })
            $(modal).modal();
        })
    })
}();


